import TagManager from 'react-gtm-module';

export const tagStepChange = (changeInfo) => {
    const {
        currentPageName = '',
        currentPageUrl = '',
        previousPageName = '',
        previousPageUrl = '',
        ...rest
    } = changeInfo;
    TagManager.dataLayer({
        dataLayer: {
            event: 'step_change',
            vp_current_page_name: currentPageName,
            vp_current_page_url: currentPageUrl,
            vp_previous_page_name: previousPageName,
            vp_previous_page_url: previousPageUrl,
            ...rest,
        },
    });
};

export const tagEvent = (e) => {
    TagManager.dataLayer({
        dataLayer: {
            ...e,
            time: Date.now(),
        },
    });
};

export const tagForm = (formData) => {
    const tagManagerArgs = {
        dataLayer: {
            event: 'form.submit',
            form: {
                ...formData,
                timestamp: Date.now(),
            },
        },
    };
    TagManager.dataLayer(tagManagerArgs);
};
